import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PrimaryButton } from "@/components/ui/PrimaryButton";
import { AppLogo } from "@/components/ui/app-logo";

// Required api for Bugsnag error boundary
interface AppErrorFallbackProps {
  error: Error;
  info: React.ErrorInfo;
  clearError: () => void;
}

export const AppErrorFallback = ({ error, clearError, info }: AppErrorFallbackProps) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col gap-12 items-center justify-center h-full w-full pt-[12vh] px-4">
      <AppLogo />

      <Card className="w-full max-w-md mx-auto h-fit">
        <CardHeader>
          <CardTitle className="mb-1 text-red-500">Oops! Something went wrong</CardTitle>
          <CardDescription>We encountered an unexpected error.</CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          {process.env.NODE_ENV !== "development" && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-800 font-mono">
                <strong>Error:</strong> {error.message}
              </p>
            </div>
          )}

          <div className="flex flex-col gap-3">
            <PrimaryButton onClick={handleReload} className="w-full">
              Reload App
            </PrimaryButton>
          </div>

          <p className="text-xs text-gray-500 text-center">If the problem persists, please contact support.</p>
        </CardContent>
      </Card>
    </div>
  );
};
